export const META_HIDRATACAO_ML = 1600;
export const HIDRAT_LIMITE_MS = 60 * 60 * 1000; // 1 hora
export const DECUBITO_LIMITE_MS = 2 * 60 * 60 * 1000; // 2 horas

const parseISO = (s) => {
  if (!s) return null;
  const [d, t] = s.split("T");
  const [y, m, day] = d.split("-").map(Number);
  const [hh, mm] = (t || "00:00").split(":").map(Number);
  return new Date(y, (m || 1) - 1, day || 1, hh || 0, mm || 0);
};
const hhmm = (dt) => `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;

// Hidratação: meta 1,6L/dia; alerta a cada 1h enquanto abaixo da meta.
export function statusHidratacao(alerta) {
  const total = alerta?.hidratacaoHojeMl || 0;
  const pct = Math.min(total / META_HIDRATACAO_ML, 1);
  const atingida = total >= META_HIDRATACAO_ML;
  const ultima = parseISO(alerta?.ultimaHidratacao);
  const textoUltima = ultima ? `Última: ${hhmm(ultima)}` : "Sem hidratação hoje";
  if (atingida) return { atrasada: false, atingida: true, total, pct, texto: textoUltima };
  const atrasada = !ultima || Date.now() - ultima.getTime() > HIDRAT_LIMITE_MS;
  return { atrasada, atingida: false, total, pct, texto: textoUltima };
}

// Medicação "na hora": horário agendado nas últimas 2h e ainda não tratado hoje.
// Também retorna a "próxima" dose futura ainda não administrada (para exibir após confirmar).
export function medicacaoNaHora(alerta) {
  const tratadas = alerta?.medicacoesTratadas || [];
  const horarios = (alerta?.horariosMedicacao || []).filter((h) => !tratadas.includes(h));
  const now = new Date();
  const nowMin = now.getHours() * 60 + now.getMinutes();
  const toMin = (h) => { const [hh, mm] = String(h).split(":").map(Number); return isNaN(hh) ? null : hh * 60 + (mm || 0); };
  let due = null;
  let prox = null;
  horarios.forEach((h) => {
    const min = toMin(h);
    if (min == null) return;
    const diff = nowMin - min;
    if (diff >= 0 && diff <= 120 && (due === null || min > due.min)) due = { horario: h, min };
    if (min > nowMin && (prox === null || min < prox.min)) prox = { horario: h, min };
  });
  return { naHora: !!due, horario: due?.horario, proxima: prox?.horario || null };
}

export function statusEvacuacao(alerta) {
  const ultima = parseISO(alerta?.ultimaEvacuacao);
  if (!ultima) return { texto: "Sem registro", desc: "", dias: null, alerta: false };
  const dd = String(ultima.getDate()).padStart(2, "0");
  const mm = String(ultima.getMonth() + 1).padStart(2, "0");
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const dia = new Date(ultima); dia.setHours(0, 0, 0, 0);
  const dias = Math.max(0, Math.round((hoje - dia) / 86400000));
  return { texto: `${dd}/${mm} ${hhmm(ultima)}`, desc: alerta?.ultimaEvacuacaoDesc || "", dias, alerta: dias >= 3 };
}

// Mudança de decúbito: só ativa se prescrita; alarme a cada 2h desde a última mudança.
import { proximaPosicaoDecubito } from "./decubito";
export function statusDecubito(alerta) {
  if (!alerta?.decubitoPrescrito) return { ativo: false };
  const ultima = parseISO(alerta?.ultimaMudancaDecubito);
  const due = !ultima || Date.now() - ultima.getTime() > DECUBITO_LIMITE_MS;
  const proxima = proximaPosicaoDecubito(alerta?.ultimaPosicaoDecubito || "");
  const proximoHorario = ultima ? new Date(ultima.getTime() + DECUBITO_LIMITE_MS) : null;
  const texto = ultima
    ? `Última: ${hhmm(ultima)} · ${alerta?.ultimaPosicaoDecubito || "-"}`
    : "Sem registro";
  return {
    ativo: true, due, proxima, ultima, proximoHorario, texto,
    orientacao: alerta?.decubitoOrientacao || "",
    frequencia: alerta?.decubitoFrequencia || "",
    cuidado: alerta?.decubitoCuidado || "Mudança de decúbito",
  };
}

